function sgallery_apply(e) {
    const big_gap_px = sgallery_rem_size("--sgrid-gap");
    const gap_px = sgallery_rem_size("--sgrid-sub-gap");
    const tile_min_px = sgallery_rem_size("--sgrid-tile-min");
    
    document.querySelectorAll(".sgalleries").forEach(elem => {
        const galleries = elem;
        const left = galleries.querySelector(".sgallery-left");
        const right = galleries.querySelector(".sgallery-right");

        const width = sgallery_content_box_width(galleries);
        const gallery_width = width - big_gap_px; // subtract middle gap

        const tracks = Math.max(1, Math.floor((gallery_width + gap_px) / (tile_min_px + gap_px)));

        const left_count = parseInt(galleries.dataset.left_count);
        const right_count = parseInt(galleries.dataset.right_count);

        const ratio_child = left_count / (left_count + right_count);

        if(left_count == 0){
            left.style.width  = 0;
            right.style.width = gallery_width;
            return;
        }

        if( right_count == 0){
            left.style.width  = gallery_width;
            right.style.width = 0;
            return;
        }

        const min_side_by_side_width = 2 * tile_min_px + big_gap_px;

        const r_tracks = tracks - sgallery_targeted_split_left_tracks(left_count, right_count, tracks, ratio_child);
        const l_tracks = tracks - r_tracks;

        if(gallery_width < min_side_by_side_width) {
            right.style.flex = `0 0 ${width}px`;
            left.style.flex = `0 0 ${width}px`;

            const min_split_width = (width/2) - gap_px;

            galleries.style.setProperty('--sgrid-tile', min_split_width + "px");
            return;
        }

        const tile_width = (gallery_width - ((tracks - 2) * gap_px)) / tracks;
        const r_width = r_tracks * tile_width + (r_tracks-1) * gap_px;
        const l_width = l_tracks * tile_width + (l_tracks-1) * gap_px;
        
        right.style.flex = `0 0 ${r_width}px`;
        left.style.flex = `0 0 ${l_width}px`;

        galleries.style.setProperty('--sgrid-tile', tile_width + "px");
    });

    sgallery_equalize_headers();
}

function sgallery_equalize_headers() {
  document.querySelectorAll('.sgalleries').forEach(galleries => {
    const headers = galleries.querySelectorAll('.sgallery-header');
    if (!headers.length) return;

    // reset any previous min-height
    headers.forEach(h => (h.style.minHeight = ''));

    let max_h = 0;
    headers.forEach(h => {
      const bounding_h = h.getBoundingClientRect().height;
      if (bounding_h > max_h) max_h = bounding_h;
    });

    headers.forEach(h => (h.style.minHeight = max_h + 'px'));
  });
}

function sgallery_targeted_split_left_tracks(left_count, right_count, tracks, ratio){
    if (tracks <= 1) return 1;
    
    let target;
    
    if(left_count < right_count){
        target = Math.floor(tracks*ratio);
    }else if (left_count > right_count){
        target = Math.ceil(tracks*ratio);
    }else{
        target = Math.round(tracks*ratio);
    }
    
    target = Math.max(Math.min(target, tracks-1), 1);

    let best_left = 1, best_cost = Infinity, best_tie = Infinity;

    for (let test_left = target + 1; test_left >= target - 1; --test_left){
        const left_rows = Math.ceil(left_count/ test_left);
        const right_rows = Math.ceil(right_count/ (tracks - test_left));
        
        const cost = Math.max(left_rows, right_rows);

        // tie-breaker: closeness to target ratio
        const tie_breaker = Math.abs(target - test_left); // how far left span is from target

        if (cost < best_cost || (cost === best_cost && tie_breaker < best_tie)){
            best_cost = cost; best_left = test_left; best_tie = tie_breaker;
        }
    }
    return best_left;
}

function sgallery_rem_size(var_name) {
    const rem_px = parseFloat(getComputedStyle(document.documentElement).fontSize);

    const raw_rem = getComputedStyle(document.documentElement).getPropertyValue(var_name).trim();
    const rem_count = parseFloat(raw_rem.match(/^([\d.]+)rem$/i)[1]);
    return rem_count * rem_px;
}

function sgallery_content_box_width(elem){
    const rect = elem.getBoundingClientRect();
    const styles = getComputedStyle(elem);

    const padding_left  = parseFloat(styles.paddingLeft);
    const padding_right = parseFloat(styles.paddingRight);
    const border_left   = parseFloat(styles.borderLeftWidth);
    const border_right  = parseFloat(styles.borderRightWidth);

    return rect.width - padding_left - padding_right - border_left - border_right;
}

addEventListener('resize', () => requestAnimationFrame(sgallery_apply), { passive: true });

addEventListener('DOMContentLoaded', () => requestAnimationFrame(sgallery_apply), { passive: true });